import type { FilterBucket, FilterSchema } from '@which/reviews-filter-definitions'
import { getBasicCommonFilterSchema } from '@which/shared'

import type { NeedsBasedAnswerOptionExtended } from '../../../../shared/types'

export const mapNeedsBasedFilterBucketOptions = ({
  matchedNeedsBasedFilterBucket,
  filterSchemas,
}: {
  matchedNeedsBasedFilterBucket?: FilterBucket
  filterSchemas: FilterSchema[]
}) => {
  return matchedNeedsBasedFilterBucket?.options?.map((option) => {
    const filterSchema = getBasicCommonFilterSchema({ filterSchemas, option })
    const exclusiveNeedsBasedOption: NeedsBasedAnswerOptionExtended = {
      ...option,
      externalId: filterSchema?.externalId || 'needs_based',
      componentType: filterSchema?.inputType,
      valueStr: null,
      valueBool: null,
      to: null,
      from: null,
      bucketLabel: matchedNeedsBasedFilterBucket.label,
      __typename: 'NeedsBasedAnswerOption',
    }

    delete exclusiveNeedsBasedOption.value

    switch (typeof option.value) {
      case 'string':
        exclusiveNeedsBasedOption.valueStr = option.value
        break
      case 'boolean':
        exclusiveNeedsBasedOption.valueBool = option.value
        break
      default:
        exclusiveNeedsBasedOption.to = option.to
        exclusiveNeedsBasedOption.from = option.from
    }

    return exclusiveNeedsBasedOption
  })
}
